import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private toggleDropdownSource = new Subject<void>();
  private getNotificationsSource = new Subject<void>(); // New BehaviorSubject

  toggleDropdown$ = this.toggleDropdownSource.asObservable();
  getNotifications$ = this.getNotificationsSource.asObservable(); // Observable for notifications


  toggleDropdown(): void {
    console.log('Toggling notification dropdown'); // Log to verify
    this.toggleDropdownSource.next();
  }

    // Method to trigger getNotifications
    triggerGetNotifications(): void {
      this.getNotificationsSource.next(); // Triggers the notification fetching process
    }
    
}
